import { Outlet } from "react-router-dom";
import { LayoutShell, LayoutRoot, SafeAreaTop, StandaloneMainContainer } from "@/components/layout/MobileLayout/mobile-layout.styles";

export const StandaloneMobileLayout = () => {
  return (
    <LayoutShell>
      <LayoutRoot>
        <SafeAreaTop />
        <StandaloneMainContainer>
          <Outlet />
        </StandaloneMainContainer>
      </LayoutRoot>
    </LayoutShell>
  );
};
